import WidgetModule from "@eisinc/Overrides/Widgets/RequestRma/RequestRmaButtons";

export * from "@eisinc/Overrides/Widgets/RequestRma/RequestRmaButtons";

export default WidgetModule;
